const FormaDePagoPOptions = [
  {
    label: "Selecciona",
    value: '',
  },
  {
    label: 'Efectivo (01)',
    value: '01'
  },
  {
  label: 'Cheque nominativo (02)',
  value: '02'
  },
  {
  label: 'Transferencia electrónica de fondos (03)',
  value: '03'
  },
  {
  label: 'Tarjeta de crédito (04)',
  value: '04'
  },
  {
  label: 'Monedero electrónico (05)',
  value: '05'
  },
  {
  label: 'Dinero electrónico (06)',
  value: '06'
  },
  {
  label: 'Vales de despensa (08)',
  value: '08'
  },
  {
  label: 'Dación en pago (12)',
  value: '12'
  },
  {
  label: 'Pago por subrogación (13)',
  value: '13'
  },
  {
  label: 'Pago por consignación (14)',
  value: '14'
  },
  {
  label: 'Condonación (15)',
  value: '15'
  },
  {
  label: 'Compensación (17)',
  value: '17'
  },
  {
  label: 'Novación (23)',
  value: '23'
  },
  {
  label: 'Confusión (24)',
  value: '24'
  },
  {
  label: 'Remisión de deuda (25)',
  value: '25'
  },
  {
  label: 'Prescripción o caducidad (26)',
  value: '26'
  },
  {
  label: 'A satisfacción del acreedor (27)',
  value: '27'
  },
  {
  label: 'Tarjeta de débito (28)',
  value: '28'
  },
  {
  label: 'Tarjeta de servicios (29)',
  value: '29'
  },
  {
  label: 'Aplicación de anticipos (30)',
  value: '30'
  },
  {
  label: 'Intermediario pagos (31)',
  value: '31'
  },
  {
  label: 'Por definir (99)',
  value: '99'
  }
];

export default FormaDePagoPOptions;